import React from 'react';
import checkIcon from '../../../assets/img/mp-step-check.svg';
import finishIcon from '../../../assets/img/mp-step-finish.svg';
import finishFilledIcon from '../../../assets/img/mp-step-finish-filled.svg';

export const StepCircle = ({ step, isActive, isCompleted = false, label, alignLeft = false }) => {
    const renderContent = () => {
        if (step === 3) {
            // Paso 3: icono de finish
            return (
                <img 
                    src={isCompleted ? finishFilledIcon : finishIcon} 
                    alt={isCompleted ? 'Finish completed' : 'Finish'} 
                    className="step-circle-icon step-circle-icon-finish"
                />
            );
        } else if (isCompleted) {
            // Pasos 1 y 2: mostrar check
            return (
                <img 
                    src={checkIcon} 
                    alt="Step completed" 
                    className="step-circle-icon step-circle-icon-check bg-white"
                />
            );
        } else {
            // Pasos 1 y 2: número
            return <span className="step-circle-number">{step}</span>;
        }
    };

    return (
        <div className="step-circle-container">
            {label && (
                <div 
                    className={`step-circle-label ${alignLeft ? 'step-circle-label-left' : 'step-circle-label-center'}`}
                >
                    {label}
                </div>
            )}
            <div 
                className={`step-circle ${isActive ? 'step-circle-active' : 'step-circle-inactive'} ${step === 3 ? 'step-circle-finish' : ''}`}
            >
                {renderContent()}
            </div>
        </div>
    );
};

